import * as React from 'react';
import LiveOrderPageView from '../layouts/LiveOrderPageView';
import { RowDataLive } from 'src/reducers/liveorderfile';
// import { UserDetail } from '../../reducers/user';

export interface LiveOrderPageViewProps {
    onComponentDidMount: () => void;
    onComponentWillMount: () => void;
    // onSubmit: () => void;
    // onFilesChange: () => void;
    // onFilesError: () => void;
    // btnElement: string;
    // btnType: string;
    // userDetails: UserDetail;
    liveOrderData: RowDataLive[];
    reload: () => void;
    onRowClick: (orderid: string, rowData: string) => void;
    onDownloadClick: (filepath: string, fileName: string) => void;
    submitCancel: (column: Object) => void;
}

class LiveOrderPage extends React.Component<LiveOrderPageViewProps> {
    render() {
        return (
            <LiveOrderPageView
                onRowClick={this.props.onRowClick}
                liveOrderData={this.props.liveOrderData}
                reload={this.props.reload}
                onDownloadClick={this.props.onDownloadClick}
                submitCancel={this.props.submitCancel}
            />
        );
    }
    componentDidMount() {
        // const url: string = window.location.href;
        this.props.onComponentDidMount();
        window.scrollTo(0, 0);
    }
    componentWillMount() {
        // const url: string = window.location.href;
        this.props.onComponentWillMount();
    }

}

export default LiveOrderPage;



// WEBPACK FOOTER //
// ./src/components/liveOrderPage/LiveOrderPage.tsx